import React, { useEffect, useState } from 'react'
import withFmsLayout from '../layout/withFmsLayout'
import { CircularProgress, LinearProgress } from "@mui/material";
import DocumentDetailsComponent from '../components/DocumentDetailsComponent';
import DocumentSearchComponent from '../components/DocumentSearchComponent';



function DocumentSearchPage() {

    const [documentId,setDocumentId] = useState(null)

    return(
      <div className='row'>
        <div className='col-md-12'>
          <DocumentSearchComponent setDocumentId={setDocumentId} />
        </div>
        <div className='col-md-12'>
          {documentId && <DocumentDetailsComponent documentId={documentId} /> }
        </div>
      </div>
    )
}

export default withFmsLayout(DocumentSearchPage);